import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/sections/PageHero";
import { IMG, servicePath } from "@/lib/content";
import { useServices } from "@/hooks/useData";
import { Reveal, ImageReveal } from "@/components/motion/Reveal";
import { Process } from "@/components/sections/Process";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCta } from "@/components/sections/FinalCta";
import { Button } from "@/components/motion/Button";

export default function Leistungen() {
  const { data: services = [] } = useServices();
  return (
    <>
      <SEO title="Leistungen" description="Privatreinigung, Unterhaltsreinigung, Büroreinigung, Umzugsreinigung, Baureinigung, Fenster & Glas, Treppenhaus & Liegenschaften, Spezialreinigung." path="/leistungen" />
      <PageHero label="Leistungen" title={["Zehn Leistungen.", "Ein Anspruch."]} image={IMG.leistungen} imageAlt="Modernes Büro mit Glaswänden" lead="Vom Einfamilienhaus bis zur Geschäftsliegenschaft, von innen bis in den Garten: Wir arbeiten strukturiert, materialgerecht und nach klaren Absprachen.">
        <Button to="/kontakt" variant="light" data-testid="leistungen-cta">Offertanfrage</Button>
      </PageHero>

      <section className="bg-paper py-24 md:py-36">
        <div className="container-x">
          <ol className="grid md:grid-cols-2 gap-x-10 gap-y-20">
            {services.map((s, i) => (
              <li key={s.slug} className={i % 2 === 1 ? "md:mt-24" : ""}>
                <Link to={servicePath(s.slug)} data-testid={`leistungen-item-${s.number}`} className="group block">
                  <ImageReveal src={s.hero} alt={s.name} className="aspect-[4/3] img-zoom" delay={0.05} sizes="(min-width:768px) 45vw, 100vw" />
                  <div className="mt-6 flex items-baseline gap-5 border-t border-line pt-5">
                    <span className="label text-mute group-hover:text-signal transition-colors duration-500">{s.number}</span>
                    <div className="flex-1">
                      <h2 className="display text-2xl md:text-3xl uppercase tracking-[-0.02em] text-ink flex items-center justify-between gap-4">
                        {s.name}
                        <ArrowUpRight size={18} strokeWidth={1.25} className="transition-transform duration-500 ease-out group-hover:translate-x-1 group-hover:-translate-y-1" />
                      </h2>
                      <p className="text-sm md:text-base text-mute mt-3 max-w-md leading-relaxed">{s.short}</p>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ol>
          <Reveal className="mt-28 border-t border-line pt-10 grid md:grid-cols-12 gap-8">
            <p className="label text-mute md:col-span-3">Weitere Leistungen</p>
            <p className="md:col-span-9 text-base md:text-lg text-ink leading-relaxed max-w-2xl">
              Grundreinigung, Praxisreinigung, Endreinigung, Ferienwohnungen und Gastronomie, hauswartungsnahe Dienstleistungen. Fragen Sie an, wir prüfen Ihr Anliegen.
            </p>
          </Reveal>
        </div>
      </section>
      <Process />
      <FAQ />
      <FinalCta />
    </>
  );
}
